<template>
  <v-container fluid class="av-page">
    <!-- LISTAGEM DE PESQUISAS -->
    <template v-if="!addUser">
      <div class="av-card av-filtro-card" v-if="user.tipo == 'ADMIN'">
        <span class="av-section-label">Empresa</span>
        <v-row dense>
          <v-col cols="12" sm="8" md="6">
            <v-autocomplete
              outlined
              dense
              hide-details
              v-model="empresaSelecionada"
              :items="empresas"
              item-text="nome"
              item-value="id"
              placeholder="Selecione a empresa"
              no-data-text="Nenhuma empresa encontrada"
              @input="carregaQuestionarios(empresaSelecionada)"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </div>

      <div class="av-card av-panel">
        <div class="av-toolbar">
          <v-text-field
            v-model="tabelaQuest.busca"
            append-icon="search"
            label="Procurar"
            outlined
            dense
            hide-details
            single-line
            class="av-busca"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            @click="addUser = true"
            :disabled="user.tipo == 'ADMIN' ? empresaSelecionada == '' : false"
          >
            <v-icon left>add</v-icon>Nova pesquisa
          </v-btn>
        </div>

        <v-data-table
          :search="tabelaQuest.busca"
          :headers="tabelaQuest.cabecalho"
          :items="tabelaQuest.conteudo"
          :loading="tabelaQuest.carregamento"
          sort-by="titulo"
          class="av-table"
          loading-text="Buscando itens..."
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
        >
          <template v-slot:[`item.ativo`]="{ item }">
            <v-chip small label :color="item.ativo ? 'success' : 'error'" text-color="white">
              {{ item.ativo ? 'Ativo' : 'Inativo' }}
            </v-chip>
          </template>
          <template v-slot:[`item.id`]="{ item }">
            <a :href="getQuestionarioURL(item)" target="_blank" class="av-link">Acessar</a>
            <v-text-field id="url" :value="getQuestionarioURL(item)" class="av-hidden-input"></v-text-field>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on" @click="editItem(item)">
                  <v-icon small color="primary">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on" @click="deleteItem(item)">
                  <v-icon small color="error">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on" @click="doCopy('url')">
                  <v-icon small color="primary">mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Copiar link</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on" @click="showQRCode(item)">
                  <v-icon small color="primary">mdi-qrcode</v-icon>
                </v-btn>
              </template>
              <span>Gerar QR Code</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-alert v-if="empresaSelecionada == ''" dense text outlined type="info" class="my-4">
              Selecione uma empresa para visualizar as pesquisas
            </v-alert>
            <v-alert v-else dense text outlined type="warning" class="my-4">
              Nenhuma pesquisa cadastrada
            </v-alert>
          </template>
        </v-data-table>
      </div>
    </template>

    <!-- CADASTRO / EDIÇÃO (STEPPER) -->
    <div v-if="addUser" class="av-card av-panel">
      <v-stepper v-model="e1" flat class="av-stepper">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Dados da Pesquisa</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2">Cadastro de Perguntas</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Revisão e Confirmação</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <div class="av-step-body">
              <span class="av-section-label">Dados da pesquisa</span>
              <v-row class="av-form-row">
                <v-col cols="12">
                  <label class="av-field-label">Título <span class="req">*</span></label>
                  <v-text-field outlined dense hide-details v-model="questionario.titulo"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <label class="av-field-label">Descrição <span class="req">*</span></label>
                  <v-text-field outlined dense hide-details v-model="questionario.descricao"></v-text-field>
                </v-col>
              </v-row>

              <v-row class="av-form-row av-toggles-row">
                <v-col cols="12" sm="6" md="4">
                  <div class="av-switch-field">
                    <v-checkbox
                      v-model="questionario.ativo"
                      :label="questionario.ativo ? 'Ativo' : 'Inativo'"
                      dense
                      hide-details
                      class="av-check ma-0 pa-0"
                    ></v-checkbox>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="av-switch-field">
                    <v-checkbox
                      v-model="questionario.exibeTermoLgpd"
                      label="Exibir Termo da Política de Privacidade"
                      dense
                      hide-details
                      class="av-check ma-0 pa-0"
                    ></v-checkbox>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="av-switch-field">
                    <v-checkbox
                      v-model="questionario.permiteAnonimo"
                      label="Permitir resposta anônima"
                      dense
                      hide-details
                      class="av-check ma-0 pa-0"
                    ></v-checkbox>
                  </div>
                </v-col>
              </v-row>

              <v-divider class="av-form-divider"></v-divider>

              <!-- Integração WhatsApp -->
              <span class="av-section-label">Integração WhatsApp</span>
              <v-row class="av-form-row">
                <v-col cols="12" sm="6" md="6">
                  <label class="av-field-label">&nbsp;</label>
                  <div class="av-switch-field">
                    <v-checkbox
                      v-model="questionario.enviaWhatsApp"
                      :label="questionario.enviaWhatsApp ? 'Envia WhatsApp' : 'Não envia WhatsApp'"
                      dense
                      hide-details
                      class="av-check ma-0 pa-0"
                    ></v-checkbox>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <label class="av-field-label">Integração</label>
                  <v-select
                    outlined
                    dense
                    hide-details
                    clearable
                    :items="integracoesWhatsApp"
                    v-model="questionario.apiWhatsApp"
                    placeholder="Selecione a integração"
                  ></v-select>
                </v-col>
              </v-row>

              <!-- Campos da integração selecionada -->
              <v-row v-if="questionario.apiWhatsApp === 'META'" class="av-form-row">
                <v-col cols="12" sm="6" md="6">
                  <label class="av-field-label">Phone Number ID</label>
                  <v-text-field outlined dense hide-details v-model="questionario.metaPhoneNumberId"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <label class="av-field-label">WABA ID</label>
                  <v-text-field outlined dense hide-details v-model="questionario.metaWabaId"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <label class="av-field-label">API Version</label>
                  <v-text-field outlined dense hide-details v-model="questionario.metaApiVersion"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <label class="av-field-label">Token</label>
                  <v-text-field outlined dense hide-details v-model="questionario.metaToken"></v-text-field>
                </v-col>
              </v-row>

              <v-row v-else-if="questionario.apiWhatsApp === 'ZAPI'" class="av-form-row">
                <v-col cols="12" md="4">
                  <label class="av-field-label">Instância ID</label>
                  <v-text-field outlined dense hide-details v-model="questionario.zapiInstanciaID"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <label class="av-field-label">Instância Token</label>
                  <v-text-field outlined dense hide-details v-model="questionario.zapiInstanciaToken"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <label class="av-field-label">Client Token</label>
                  <v-text-field outlined dense hide-details v-model="questionario.zapiClientToken"></v-text-field>
                </v-col>
              </v-row>

              <v-row v-else-if="questionario.apiWhatsApp === 'NEORON'" class="av-form-row">
                <v-col cols="12" sm="6" md="6">
                  <label class="av-field-label">API Key</label>
                  <v-text-field outlined dense hide-details v-model="questionario.neoronApiKey"></v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="av-step-actions">
              <v-spacer></v-spacer>
              <v-btn text @click="close">Cancelar</v-btn>
              <v-btn depressed color="primary" @click="salvarQuest()">Continuar</v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content step="2">
            <div class="av-step-body">
              <div class="av-toolbar">
                <v-text-field
                  v-model="tabelaPergunta.busca"
                  append-icon="search"
                  label="Procurar"
                  outlined
                  dense
                  hide-details
                  single-line
                  class="av-busca"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn depressed color="primary" @click="dialog = true">
                  <v-icon left>add</v-icon>Nova pergunta
                </v-btn>
              </div>

              <v-data-table
                :search="tabelaPergunta.busca"
                :headers="tabelaPergunta.cabecalho"
                :items="tabelaPergunta.conteudo"
                sort-by="titulo"
                class="av-table"
                :footer-props="{
                  'items-per-page-text': 'Linhas por página',
                  'items-per-page-all-text': 'Tudo',
                }"
              >
                <template v-slot:[`item.tipo`]="{ item }">
                  <span v-if="item.tipo == 'NPS'">Padrão NPS</span>
                  <span v-else-if="item.tipo == 'MÚLTIPLA ESCOLHA'">Múltipla Escolha</span>
                  <span v-else-if="item.tipo == 'FEEDBACK'">Feedback</span>
                  <span v-else-if="item.tipo == 'TELEFONE'">Telefone</span>
                  <span v-else-if="item.tipo == 'ESCALA'">Escala</span>
                  <!-- dicotômica refere-se as perguntas de respostas fechadas como sim ou não -->
                  <span v-else-if="item.tipo == 'DICOTÔMICA'">Pergunta Fechada</span>
                  <span v-else-if="item.tipo == 'ESCOLHA ÚNICA'">Escolha Única</span>
                  <span v-else-if="item.tipo == 'ESCOLHA ÚNICA COM FOTO'">Escolha Única com Foto</span>
                  <span v-else-if="item.tipo == 'INFORMATIVO'">Informativo</span>
                  <span v-else>{{ item.tipo }}</span>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" @click="editItemPerg(item)">
                        <v-icon small color="primary">mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" @click="deleteItemPerg(item)">
                        <v-icon small color="error">mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </template>
                <template v-slot:no-data>
                  <v-alert dense text outlined type="warning" class="my-4">
                    Nenhuma pergunta inserida
                  </v-alert>
                </template>
              </v-data-table>
            </div>
            <div class="av-step-actions">
              <v-spacer></v-spacer>
              <v-btn text @click="close">Cancelar</v-btn>
              <v-btn depressed color="primary" @click="e1 = 3">Continuar</v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content step="3">
            <div class="av-step-body">
              <span class="av-section-label">Resumo</span>
              <p class="av-resumo-titulo">{{ questionario.titulo }}</p>
              <p class="av-page-subtitle mb-3" v-if="questionario.descricao">{{ questionario.descricao }}</p>
              <v-list dense class="av-resumo-lista">
                <v-list-item v-for="perguntaQuest in tabelaPergunta.conteudo" :key="perguntaQuest.id" class="av-resumo-item">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="primary">mdi-help-circle-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="d-flex align-center flex-wrap">
                      <span class="mr-2">{{ perguntaQuest.titulo }}</span>
                      <v-chip x-small label outlined color="primary">{{ rotuloTipoPergunta(perguntaQuest.tipo) }}</v-chip>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="perguntaQuest.descricao">{{ perguntaQuest.descricao }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="av-resumo-peso">
                    <span class="av-page-subtitle">Peso {{ perguntaQuest.peso }}</span>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
            <div class="av-step-actions">
              <v-spacer></v-spacer>
              <v-btn depressed color="primary" @click="close">Finalizar</v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <!-- DIÁLOGO INSERIR/EDITAR PERGUNTA -->
    <v-dialog v-model="dialog" persistent max-width="900px" scrollable>
      <v-card>
        <v-card-title class="av-dialog-title">{{ editedIndexPerg === -1 ? 'Adicionar pergunta' : 'Editar pergunta' }}</v-card-title>
        <p class="av-dialog-hint">* indica preenchimento obrigatório</p>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-row class="av-form-row">
            <v-col cols="12">
              <label class="av-field-label">Título <span class="req">*</span></label>
              <v-text-field outlined dense hide-details v-model="pergunta.titulo"></v-text-field>
            </v-col>
            <v-col cols="12" md="8">
              <label class="av-field-label">Descrição</label>
              <v-text-field outlined dense hide-details v-model="pergunta.descricao"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="av-field-label">Peso</label>
              <v-text-field type="tel" outlined dense hide-details v-model="pergunta.peso"></v-text-field>
            </v-col>
            <v-col cols="12">
              <label class="av-field-label">Tipo de pergunta <span class="req">*</span></label>
              <v-select outlined dense hide-details :items="tiposPergunta" v-model="pergunta.tipo" placeholder="Selecione o tipo de pergunta"></v-select>
              <v-alert v-if="descricaoTipoPergunta" dense text type="info" class="av-tipo-info mt-3 mb-0">
                {{ descricaoTipoPergunta }}
              </v-alert>
            </v-col>

            <!-- ESCALA -->
            <v-col cols="12" v-if="pergunta.tipo == 'ESCALA'">
              <label class="av-field-label">Escala</label>
              <div class="av-slider-box">
                <v-slider dense max="10" min="1" v-model="pergunta.escalaValor" thumb-label="always" :thumb-size="24" hide-details></v-slider>
              </div>
            </v-col>

            <!-- ESCOLHA ÚNICA -->
            <v-col cols="9" v-if="pergunta.tipo == 'ESCOLHA ÚNICA'">
              <label class="av-field-label">Opção</label>
              <v-text-field dense v-model="opcao" counter="100" maxlength="100" outlined hide-details></v-text-field>
            </v-col>
            <v-col cols="3" v-if="pergunta.tipo == 'ESCOLHA ÚNICA'" class="d-flex align-end">
              <v-btn block depressed color="primary" @click="adicionaOpcoesEscolha">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="pergunta.tipo == 'ESCOLHA ÚNICA'">
              <v-alert v-if="pergunta.escolhas.length == 0" dense text outlined type="warning" class="ma-0">
                Nenhuma opção informada
              </v-alert>
              <div v-else :key="x" class="av-opcoes">
                <v-list dense v-for="(item, index) in pergunta.escolhas" :key="`${index}-${item}`" class="pa-0">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0">
                      <div>
                        <v-btn icon small @click="editarOpcao(item)"><v-icon small color="primary">mdi-pencil</v-icon></v-btn>
                        <v-btn icon small @click="removerOpcao(item)"><v-icon small color="error">mdi-delete</v-icon></v-btn>
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index < pergunta.escolhas.length - 1" :key="index"></v-divider>
                </v-list>
              </div>
            </v-col>

            <!-- INFORMATIVO -->
            <v-col cols="12" v-if="pergunta.tipo == 'INFORMATIVO'">
              <label class="av-field-label">Informação</label>
              <v-textarea outlined dense hide-details v-model="pergunta.textoInformativo"></v-textarea>
            </v-col>

            <!-- ESCOLHA ÚNICA COM FOTO -->
            <v-col cols="12" sm="5" v-if="pergunta.tipo == 'ESCOLHA ÚNICA COM FOTO'">
              <label class="av-field-label">Texto</label>
              <v-text-field dense v-model="texto" counter="100" maxlength="100" outlined hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="5" v-if="pergunta.tipo == 'ESCOLHA ÚNICA COM FOTO'">
              <label class="av-field-label">URL da Imagem</label>
              <v-text-field dense v-model="imagemUrl" outlined hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" v-if="pergunta.tipo == 'ESCOLHA ÚNICA COM FOTO'" class="d-flex align-end">
              <v-btn block depressed color="primary" @click="adicionaOpcoesEscolhaFoto">
                <v-icon>{{ editandoOpcaoFotoIndex === -1 ? 'mdi-plus' : 'mdi-content-save' }}</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="pergunta.tipo == 'ESCOLHA ÚNICA COM FOTO'">
              <v-alert v-if="pergunta.escolhas.length == 0" dense text outlined type="warning" class="ma-0">
                Nenhuma opção informada
              </v-alert>
              <div v-else :key="x" class="av-opcoes">
                <v-list dense v-for="(item, index) in pergunta.escolhas" :key="`${index}-${item.nome}`" class="pa-0">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-list-item-title>
                        <img width="100px" :src="item.foto">
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content class="py-0">
                      <v-list-item-title>{{ item.nome }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0">
                      <div>
                        <v-btn icon small @click="editarOpcaoFoto(item)"><v-icon small color="primary">mdi-pencil</v-icon></v-btn>
                        <v-btn icon small @click="removerOpcao(item)"><v-icon small color="error">mdi-delete</v-icon></v-btn>
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index < pergunta.escolhas.length - 1" :key="index"></v-divider>
                </v-list>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">Cancelar</v-btn>
          <v-btn depressed color="primary" @click="salvarPergunta()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#2f7d74" :is-full-page="fullPage"></loading>

    <!-- Modal para exibir QR Code -->
    <v-dialog v-model="dialogQRCode" max-width="500px" persistent>
      <v-card>
        <v-card-title class="av-dialog-title">
          <v-icon left color="primary">mdi-qrcode</v-icon>
          QR Code da Pesquisa
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <QRCodeGenerator
            v-if="selectedQuestionario"
            :url="getQuestionarioURL(selectedQuestionario)"
            :title="selectedQuestionario.titulo"
            subtitle="Escaneie o código para acessar a pesquisa"
            :size="250"
            :logoSize="50"
            :showActions="true"
            :showURL="true"
            @qr-generated="onQRGenerated"
            @qr-downloaded="onQRDownloaded"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogQRCode = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { baseApiUrl } from '@/global'
import Snackbar from '../componentes/snackbar.vue'
import axios from 'axios'
import { mapState } from 'vuex'
import QRCodeGenerator from '../componentes/QRCodeGenerator.vue'
import Loading from 'vue-loading-overlay'

export default {
  components: { Snackbar, QRCodeGenerator, Loading },
  data: () => ({
    e1: 1,
    addUser: false,
    dialog: false,
    configAccess: false,
    tabelaQuest: {
      busca: '',
      cabecalho: [
        { text: 'Titulo', align: 'start', value: 'titulo', },
        { text: 'Descrição', value: 'descricao' },
        { text: 'Status', value: 'ativo' },
        { text: 'URL', value: 'id' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      carregamento: false,
      conteudo: [],
    },
    tabelaPergunta: {
      busca: '',
      cabecalho: [
        { text: 'Peso', align: 'start', value: 'peso', },
        { text: 'Titulo', align: 'start', value: 'titulo', },
        { text: 'Descrição', value: 'descricao' },
        { text: 'Tipo Pergunta', value: 'tipo' },
        { text: 'Ações', value: 'action', align: 'right', sortable: false },
      ],
      carregamento: false,
      conteudo: [],
    },
    perguntas: [],
    tiposPergunta: [
      { text: 'Padrão NPS', value: 'NPS' },
      { text: 'Múltipla Escolha', value: 'MÚLTIPLA ESCOLHA' },
      { text: 'Feedback', value: 'FEEDBACK' },
      { text: 'Telefone', value: 'TELEFONE' },
      { text: 'Escala', value: 'ESCALA' },
      { text: 'Pergunta Fechada', value: 'DICOTÔMICA' },
      { text: 'Escolha Única', value: 'ESCOLHA ÚNICA' },
      { text: 'Escolha Única com Foto', value: 'ESCOLHA ÚNICA COM FOTO' },
      { text: 'Informativo', value: 'INFORMATIVO' },
    ],
    integracoesWhatsApp: ['META', 'ZAPI', 'NEORON'],
    idQuestionario: '',
    editedIndex: -1,
    editedIndexPerg: -1,
    questionario: {
      titulo: '',
      descricao: '',
      tokenWhatsApp: '',
      apiWhatsApp: '',
      zapiInstanciaID: '',
      zapiInstanciaToken: '',
      zapiClientToken: '',
      metaPhoneNumberId: '',
      metaWabaId: '',
      metaApiVersion: '',
      metaToken: '',
      neoronApiKey: '',
      enviaWhatsApp: true,
      ativo: true,
      empresaId: '',
      exibeTermoLgpd: true,
      permiteAnonimo: false,
    },
    defaultQuest: {
      titulo: '',
      descricao: '',
      tokenWhatsApp: '',
      apiWhatsApp: '',
      zapiInstanciaID: '',
      zapiInstanciaToken: '',
      zapiClientToken: '',
      metaPhoneNumberId: '',
      metaWabaId: '',
      metaApiVersion: '',
      metaToken: '',
      neoronApiKey: '',
      enviaWhatsApp: true,
      ativo: true,
      empresaId: '',
      exibeTermoLgpd: true,
      permiteAnonimo: false,
    },
    pergunta: {
      tipo: '',
      titulo: '',
      descricao: '',
      questionarioId: '',
      padraoNPS: true,
      escalaValor: 10,
      escolhas: [],
      peso: 1,
    },
    defaultPergunta: {
      tipo: '',
      titulo: '',
      descricao: '',
      questionarioId: '',
      padraoNPS: true,
      escalaValor: 10,
      escolhas: [],
      peso: 1,
    },
    empresas: [],
    empresaSelecionada: '',
    opcao: '',
    tokenWhatsApp: '',
    apiWhatsApp: '',
    zapiInstanciaID: '',
    zapiInstanciaToken: '',
    zapiClientToken: '',
    texto: '',
    imagemUrl: '',
    editandoOpcaoFotoIndex: -1,
    tabela: {
      cabecalho: [
        { text: 'Pergunta', align: 'start', value: 'produtoId', },
        { text: 'Quantidade', align: 'start', value: 'quantidadeLimite', },
        { text: 'Ações', value: 'action', align: 'center', sortable: true },
      ],
    },
    x: 0,
    dialogQRCode: false,
    selectedQuestionario: null,
    isLoading: false,
    fullPage: true,
  }),

  /* computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'ADICIONAR NOVO USUÁRIO' : 'EDITAR USUÁRIO'
    },
  }, */

  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    user: state => state.userObj,
    companyobj: state => state.companyObj,
    formTitle() {
      return this.editedIndex === -1 ? 'ADICIONAR NOVO USUÁRIO' : 'EDITAR USUÁRIO'
    },
    descricaoTipoPergunta() {
      const infos = {
        'NPS': 'Padrão NPS: o respondente escolhe uma nota de 0 a 10 (com carinhas) indicando o quanto recomendaria. É a métrica clássica de recomendação.',
        'MÚLTIPLA ESCOLHA': 'Escala de satisfação com quatro níveis fixos — Ruim, Bom, Ótimo e Excelente. O respondente toca em um deles.',
        'FEEDBACK': 'Campo de texto livre para o respondente escrever um comentário ou sugestão.',
        'TELEFONE': 'Campo para o respondente informar o número de telefone (com máscara). Útil para contato posterior.',
        'ESCALA': 'Escala numérica de 1 até o valor máximo definido abaixo, onde 1 é o mais negativo e o maior número o mais positivo.',
        'DICOTÔMICA': 'Pergunta fechada com apenas duas opções de resposta: Sim ou Não.',
        'ESCOLHA ÚNICA': 'O respondente escolhe uma única opção entre as alternativas de texto que você cadastrar abaixo.',
        'ESCOLHA ÚNICA COM FOTO': 'O respondente escolhe uma única opção, cada uma com texto e imagem. Cadastre as opções (texto + URL da foto) abaixo.',
        'INFORMATIVO': 'Exibe um texto informativo ao respondente, sem coletar resposta. Útil para instruções ou mensagens de boas-vindas.',
      }
      return infos[this.pergunta.tipo] || ''
    }
  }),

  watch: {
    configAccess(val) {
      if (val == true)
        this.openDialog()
    },
  },

  mounted() {
    if (this.user.tipo == 'ADMIN') {
      this.carregaEmpresas()
    } else {
      this.carregaQuestionarios(this.companyobj.id)
    }
  },

  methods: {
    retornaBaseApiUrl() {
      return baseApiUrl.replace('/api', '')
    },

    rotuloTipoPergunta(tipo) {
      const t = this.tiposPergunta.find(x => x.value === tipo)
      return t ? t.text : tipo
    },

    async carregaEmpresas() {
      await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
    },

    async carregaQuestionarios(id) {
      this.tabelaQuest.carregamento = true
      this.tabelaQuest.conteudo = []
      await axios.get(baseApiUrl + 'Questionarios?filter={"where":{"empresaId":"' + id + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabelaQuest.carregamento = false
            this.tabelaQuest.conteudo = response.data
          }
        })
    },

    async carregaPerguntas(questionarioId) {
      axios.get(baseApiUrl + 'Perguntas?filter={"where":{"questionarioId":"' + questionarioId + '"}, "order": "peso ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length) {
            this.tabelaPergunta.conteudo = response.data
          }
        })
    },

    openDialog() {
      this.dialog = true
    },

    editItem(item) {
      this.editedIndex = this.tabelaQuest.conteudo.indexOf(item)
      this.idQuestionario = item.id
      this.questionario = Object.assign({}, item)
      this.addUser = true
    },

    editItemPerg(item) {
      this.editedIndexPerg = this.tabelaPergunta.conteudo.indexOf(item)
      this.pergunta = Object.assign({}, item)
      if (!this.pergunta.escolhas) {
        this.pergunta.escolhas = []
      }
      this.dialog = true
    },

    async deleteItem(item) {
      var r = confirm('Deseja realmente excluir o questionário ' + item.titulo + '?')
      if (r == true) {
        await axios.delete(baseApiUrl + 'Questionarios/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#00253E", "Operação realizada com sucesso!", "white")
            this.carregaQuestionarios(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
          })
      }
    },

    async deleteItemPerg(item) {
      var r = confirm('Deseja realmente excluir a Pergunta: ' + item.titulo + '?')
      if (r == true) {
        await axios.delete(baseApiUrl + 'Perguntas/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#00253E", "Operação realizada com sucesso!", "white")
            this.carregaPerguntas(item.questionarioId)
          })
      }
    },

    close() {
      this.addUser = false
      this.e1 = 1
      this.carregaQuestionarios(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
      setTimeout(() => {
        this.tabelaPergunta.conteudo = []
        this.questionario = Object.assign({}, this.defaultQuest)
        this.editedIndex = -1
      }, 300)
    },

    closeDialog() {
      this.dialog = false
      setTimeout(() => {
        this.pergunta = Object.assign({}, this.defaultPergunta)
        this.editedIndexPerg = -1
        this.texto = ''
        this.imagemUrl = ''
        this.editandoOpcaoFotoIndex = -1
      }, 300)
    },

    async salvarQuest() {
      if (this.questionario.titulo == '' || this.questionario.descricao == '') {
        var vm = this;
        vm.$refs.chamaSnackbar.snack("warning", "Preencha os campos Titulo e Descrição!")
      } else {
        this.questionario.empresaId = this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id
        axios.post(baseApiUrl + 'Questionarios/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.questionario)
          .then(response => {
            if (response.data) {
              this.carregaQuestionarios(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
              this.carregaPerguntas(response.data.id)
              this.idQuestionario = response.data.id
              this.e1 = 2
            }
          }).catch(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "#BF4554")
          })
      }
    },

    async salvarPergunta() {
      var vm = this;

      if (this.pergunta.tipo == 'ESCALA' && !this.pergunta.escalaValor) {
        vm.$refs.chamaSnackbar.snack("orange", "Informe a escala", "white")
        return
      }

      if ((this.pergunta.tipo == 'ESCOLHA ÚNICA' || this.pergunta.tipo == 'ESCOLHA ÚNICA COM FOTO') && this.pergunta.escolhas.length == 0) {
        vm.$refs.chamaSnackbar.snack("orange", "Informe pelo menos uma opção", "white")
        return
      }

      if (this.pergunta.tipo == 'INFORMATIVO' && !this.pergunta.textoInformativo) {
        vm.$refs.chamaSnackbar.snack("orange", "Insira o texto informativo", "white")
        return
      }

      this.pergunta.questionarioId = this.idQuestionario
      this.pergunta.peso = parseInt(this.pergunta.peso)

      axios.post(baseApiUrl + 'Perguntas/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.pergunta)
        .then(res => {
          if (res.data != null) {
            this.carregaPerguntas(this.idQuestionario)
            this.closeDialog()
            vm.$refs.chamaSnackbar.snack("#00253E", "Operação realizada com sucesso!", "white")
          }
        }).catch(() => {
          vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "#BF4554")
        })
    },

    save() {
      if (this.editedIndex != -1) {
        axios.patch(baseApiUrl + 'Questionarios/' + this.editedItem.id + '?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(res => {
            if (res.data != null) {
              if (res.data.id == this.user.id) {
                sessionStorage.setItem('user', JSON.stringify(res.data))
                this.$store.dispatch('SetUser')
              }
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#00253E", "Operação realizada com sucesso!", "white")
              this.carregaQuestionarios(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
            }
          }).catch(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "#BF4554")
          })
      } else {
        var password = this.editedItem.email.split('@')
        this.editedItem.companyId = this.companyobj.id
        this.editedItem.password = password[0] + "@123"
        axios.post(baseApiUrl + 'Questionarios/?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(res => {
            if (res.data != null) {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#00253E", "Operação realizada com sucesso!", "white")
              this.carregaQuestionarios(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
            }
          }).catch(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "#BF4554")
          })
      }
      this.close()
    },

    doCopy(id) {
      var vm = this;
      try {
        let copyText = document.getElementById(id);
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
        document.execCommand("copy");
        vm.$refs.chamaSnackbar.snack("success", "Chave copiada para a área de transferência!", "white")
      } catch (error) {
        vm.$refs.chamaSnackbar.snack("warning", "Problema ao copiar chave para a área de transferência", "white")
      }
    },

    adicionaOpcoesEscolha() {
      var vm = this

      if (!this.opcao) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Informe uma opção!", "ATENÇÃO")
      } else {
        this.pergunta.escolhas.push(this.opcao)
        setTimeout(() => {
          this.opcao = ''
        }, 50)
      }
    },

    adicionaOpcoesEscolhaFoto() {
      var vm = this

      if (!this.texto || !this.imagemUrl) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos!", "ATENÇÃO")
      } else {
        const opcaoFoto = {
          "nome": this.texto,
          "foto": this.imagemUrl,
        }

        if (this.editandoOpcaoFotoIndex >= 0) {
          this.pergunta.escolhas.splice(this.editandoOpcaoFotoIndex, 1, opcaoFoto)
        } else {
          this.pergunta.escolhas.push(opcaoFoto)
        }

        setTimeout(() => {
          this.texto = ''
          this.imagemUrl = ''
          this.editandoOpcaoFotoIndex = -1
        }, 50)
      }
    },

    editarOpcao(item) {
      this.opcao = item
      this.removerOpcao(item)
    },

    editarOpcaoFoto(item) {
      this.texto = item.nome
      this.imagemUrl = item.foto
      this.editandoOpcaoFotoIndex = this.pergunta.escolhas.indexOf(item)
    },

    removerOpcao(opcao) {
      // this.pergunta.escolhas = this.pergunta.escolhas.filter(opcao => item != opcao)
      let listaFiltrada = this.pergunta.escolhas.filter(function (item) {
        return item !== opcao;
      });

      this.pergunta.escolhas = listaFiltrada
      this.x++
    },

    showQRCode(item) {
      this.selectedQuestionario = item
      this.dialogQRCode = true
    },

    getQuestionarioURL(questionario) {
      return this.retornaBaseApiUrl() + 'questionarios?q=' + questionario.id
    },

    onQRGenerated(qrCode) {
      // eslint-disable-next-line no-console
      console.log('QR Code gerado:', qrCode);
    },

    onQRDownloaded() {
      this.$refs.chamaSnackbar.snack("success", "QR Code baixado com sucesso!", "white")
    },
  },
}
</script>

<!-- Estilos globais legados (mantidos para telas ainda não migradas) -->
<style>
.theme--light.v-data-table thead tr th {
  color: white;
}
</style>

<style scoped>
  .av-page {
    padding: 20px 24px;
  }

  .av-filtro-card {
    padding: 16px;
    margin-bottom: 16px;
  }

  .av-panel {
    padding: 16px 16px 8px;
  }

  .av-section-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .4px;
    text-transform: uppercase;
    color: var(--av-text-soft);
    margin: 4px 0 10px;
  }

  .av-field-label {
    display: block;
    font-size: 12.5px;
    font-weight: 500;
    color: #2c3a3a;
    margin-bottom: 6px;
  }

  .av-field-label .req {
    color: #c62828;
  }

  .av-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  .av-busca { max-width: 280px; }

  @media (max-width: 599px) {
    .av-toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .av-toolbar .v-spacer {
      display: none;
    }

    .av-busca {
      max-width: none;
    }

    .av-toolbar .v-btn {
      width: 100%;
    }
  }

  .av-dialog-title {
    font-size: 17px;
    font-weight: 600;
    color: var(--av-text);
    padding-bottom: 2px;
  }

  .av-dialog-hint {
    margin: 0;
    padding: 0 16px 12px;
    font-size: 13px;
    color: var(--av-text-soft);
  }

  .av-form-divider {
    margin: 20px 0;
  }

  /* Respiro extra acima da linha de toggles em relação aos campos acima */
  .av-toggles-row {
    margin-top: 16px;
  }

  /* Booleano com aparência de campo (igual a Empresas/Usuários) */
  .av-switch-field {
    display: flex;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.38);
    padding: 6px 12px;
    min-height: 40px;
  }

  ::v-deep .av-check .v-input__slot {
    margin: 0;
  }

  ::v-deep .av-check .v-input__control {
    min-height: auto;
  }

  ::v-deep .av-check .v-label {
    color: rgba(0, 0, 0, 0.7);
  }

  /* Respiro confortável entre os campos do formulário */
  ::v-deep .av-form-row > [class*="col"] {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  /* Link "Acessar" na coluna de URL */
  .av-link {
    color: var(--av-primary);
    text-decoration: none;
    font-weight: 500;
  }

  .av-link:hover {
    text-decoration: underline;
  }

  /* Campo oculto usado para copiar a URL para a área de transferência */
  .av-hidden-input {
    padding: 1px;
    position: absolute;
    left: -99999px;
  }

  /* Stepper sem moldura, integrado ao cartão */
  ::v-deep .av-stepper.v-stepper {
    box-shadow: none;
  }

  ::v-deep .av-stepper .v-stepper__content {
    padding: 16px 4px 0;
  }

  .av-step-body {
    min-height: 160px;
    padding-bottom: 8px;
  }

  .av-step-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    border-top: 1px solid var(--av-border);
    padding-top: 12px;
    margin-top: 8px;
  }

  /* Caixa do slider de escala */
  .av-slider-box {
    border: 1px solid var(--av-border);
    border-radius: var(--av-radius);
    padding: 18px 16px 0;
  }

  /* Alert que explica o tipo de pergunta selecionado */
  ::v-deep .av-tipo-info {
    font-size: 13px;
  }

  ::v-deep .av-tipo-info .v-alert__content {
    line-height: 1.45;
  }

  /* Lista de opções (escolha única / com foto) */
  .av-opcoes {
    border: 1px solid var(--av-border);
    padding: 4px 12px;
  }

  /* Resumo (passo de confirmação) */
  .av-resumo-titulo {
    font-size: 18px;
    font-weight: 600;
    color: var(--av-text);
    margin: 0 0 2px;
  }

  ::v-deep .av-resumo-lista .v-list-item {
    min-height: 44px;
    border-bottom: 1px solid #eef1f1;
  }

  ::v-deep .av-resumo-lista .v-list-item:last-child {
    border-bottom: none;
  }

  ::v-deep .av-resumo-item .v-list-item__subtitle {
    font-size: 12.5px;
    color: var(--av-text-soft);
  }

  .av-resumo-peso {
    align-self: center;
  }

  /* Cabeçalho legível, sobrepondo o CSS global herdado das telas legadas */
  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th {
    color: var(--av-text-soft) !important;
    background: #f7f9f9;
    font-size: 12.5px;
    font-weight: 600;
    white-space: nowrap;
    border-bottom: 1px solid var(--av-border) !important;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th,
  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    height: 46px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    border-bottom: 1px solid #eef1f1 !important;
    font-size: 13.5px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr:hover {
    background: #f5f8f8;
  }

  ::v-deep .av-table.v-data-table {
    background: transparent;
  }
</style>